export default __webpack_public_path__ + "static/media/eyeView.9f34ac9f.svg";